angular.module('bizmetryApp').controller('ProfileDetailsDialogController', function (
  $scope, $rootScope, $mdDialog, profile, template, initialTabIndex, $mdToast,
  ProfileService, $timeout, dialogService, $interval,
  PermissionService
) {

  // ========================================
  // DATOS BÁSICOS
  // ========================================

  var AGENTS_TAB_INDEX         = 3;
  var CLIENTS_TAB_INDEX        = 4;
  var BIZ_EVENTS_TAB_INDEX     = 6;
  var BIZ_INTERCEPTORS_TAB_INDEX = 7;
  var AGENTS_REFRESH_INTERVAL_MS = 15000;
  var agentsRefreshPromise = null;

  $scope.template = template;
  $scope.profile = profile;
  $scope.selectedTabIndex = initialTabIndex || 0;

  console.log('initialTabindex->', initialTabIndex);
  console.log('TEMPLATE->', $scope.template);

  // ========================================
  // CERRAR DIALOG
  // ========================================

  $scope.close = function () {
    // Consultar el estado del workflow edit mode publicado en $rootScope
    // por EnvWorkflowViewerController via $rootScope._envWorkflowEditMode
    var editMode   = !!$rootScope._envWorkflowEditMode;
    var hasChanges = !!$rootScope._envWorkflowHasChanges;
    var cancelFn   = $rootScope._envWorkflowCancelFn;

    if (editMode && hasChanges) {
      // Hay cambios pendientes en el pipeline — pedir confirmación antes de cerrar
      dialogService.showDecisionDialog(
        'Discard Changes',
        'You have unsaved changes in the release pipeline.<br><br>' +
        'If you close now, <strong>all modifications will be permanently lost</strong> ' +
        'and the pipeline will revert to its last saved state.<br><br>' +
        'Are you sure you want to close and discard all changes?'
      ).then(function (decision) {
        if (decision === 'proceed') {
          // Delegar el reset al propio EnvWorkflowViewerController
          if (typeof cancelFn === 'function') {
            // Forzar skip de confirmación ya que el usuario ya confirmó
            $rootScope._envWorkflowHasChanges = false;
            cancelFn();
          }
          $rootScope._envWorkflowEditMode    = false;
          $rootScope._envWorkflowHasChanges  = false;
          $rootScope._envWorkflowCancelFn    = null;
          stopAgentsPolling();
          $mdDialog.hide();
        }
      });
      return;
    }

    if (editMode && !hasChanges && typeof cancelFn === 'function') {
      // Edit mode activo pero sin cambios — salir limpiamente del edit mode
      cancelFn();
    }

    $rootScope._envWorkflowEditMode   = false;
    $rootScope._envWorkflowHasChanges = false;
    $rootScope._envWorkflowCancelFn   = null;
    stopAgentsPolling();
    $mdDialog.hide();
  };

  // ========================================
  // BASIC DETAILS - Editar Profile
  // ========================================

  $scope.editingProfile = false;

  $scope.startEditProfile = function () {
    $scope.editingProfile = true;
    $scope.editableProfile = {
      profileName:        $scope.profile.profileName,
      profileDescription: $scope.profile.profileDescription,
      profileProjectName: $scope.profile.profileProjectName
    };
  };

  $scope.cancelEditProfile = function () {
    $scope.editingProfile = false;
  };

  $scope.saveProfileChanges = function () {
    if (!profile.id) return;

    const updatedData = {
      profileName:        $scope.editableProfile.profileName,
      profileDescription: $scope.editableProfile.profileDescription,
      profileProjectName: $scope.editableProfile.profileProjectName
    };

    ProfileService.updateProfileField(profile.id, updatedData)
      .then(() => {
        $scope.profile.profileName        = updatedData.profileName;
        $scope.profile.profileDescription = updatedData.profileDescription;
        $scope.profile.profileProjectName = updatedData.profileProjectName;
        $scope.editingProfile = false;
        console.log('✅ Profile updated successfully');
      })
      .catch((err) => {
        console.error('❌ Failed to update profile:', err);
        dialogService.showErrorDialog(
          'Profile Update Error',
          'An error occurred while updating the profile. Details: ' + (err.data?.message || 'Unknown error')
        );
      });
  };

  $scope.hasProfileChanges = function () {
    if (!$scope.profile || !$scope.editableProfile) return false;
    return (
      $scope.profile.profileName        !== $scope.editableProfile.profileName        ||
      $scope.profile.profileDescription !== $scope.editableProfile.profileDescription ||
      $scope.profile.profileProjectName !== $scope.editableProfile.profileProjectName
    );
  };

  $scope.isProfileFormValid = function () {
    const p = $scope.editableProfile;
    return p && p.profileName && p.profileDescription && p.profileProjectName && $scope.hasProfileChanges();
  };

  $scope.toggleProfileEnabled = function (profile) {
    ProfileService.updateProfileField(profile.id, { isEnabled: profile.isEnabled })
      .then(() => {
        console.log(`🔁 Profile enabled set to ${profile.isEnabled}`);
      })
      .catch((err) => {
        console.error('❌ Error updating profile enabled status:', err);
      });
  };

  $scope.deleteProfile = function (profile) {
    dialogService.showDecisionDialog(
      'Delete Profile',
      `Are you sure you want to delete profile "${profile.profileName}"? All associated configurations will be irreversibly discarded`
    ).then(function (decision) {
      if (decision === 'proceed') {
        ProfileService.deleteProfile(profile.id)
          .then(function () {
            console.log('✅ Profile deleted:', profile.profileName);
            stopAgentsPolling();
            $mdDialog.hide('deleted');
          })
          .catch(function (err) {
            console.error('❌ Failed to delete profile:', err);
            alert('Failed to delete profile. Please try again.');
          });
      }
    });
  };

  $scope.refreshProfile = function () {
    if (!profile || !profile.id) {
      console.error('❌ No profile loaded to refresh');
      return;
    }

    ProfileService.getProfileById(profile.id)
      .then(function (response) {
        $scope.profile = response.data;
        console.log('✅ Profile refreshed:', $scope.profile);
      })
      .catch(function (error) {
        console.error('❌ Error refreshing profile:', error);
      });
  };

  // ========================================
  // TAB CONTROL
  // ========================================

  function triggerAgentsRefresh() {
    $scope.$broadcast('refreshAgents');
  }

  function startAgentsPolling() {
    if (agentsRefreshPromise) return;

    console.log('Agents polling started');

    triggerAgentsRefresh();

    agentsRefreshPromise = $interval(function () {
      if ($scope.selectedTabIndex === AGENTS_TAB_INDEX) {
        triggerAgentsRefresh();
      }
    }, AGENTS_REFRESH_INTERVAL_MS);
  }

  function stopAgentsPolling() {
    if (agentsRefreshPromise) {
      $interval.cancel(agentsRefreshPromise);
      agentsRefreshPromise = null;
      console.log('Agents polling stopped');
    }
  }

  function syncTabPolling(tabIndex) {
    console.log('Tab changed →', tabIndex);

    if (tabIndex === AGENTS_TAB_INDEX) {
      startAgentsPolling();
    } else {
      stopAgentsPolling();
    }

    // Clients keep a copy of environment names: reload on entry so renames show up.
    if (tabIndex === CLIENTS_TAB_INDEX) {
      $scope.$broadcast('clients:tab-selected');
    }

    if (tabIndex === BIZ_EVENTS_TAB_INDEX) {
      $scope.$broadcast('biz-events:tab-selected');
    }

    if (tabIndex === BIZ_INTERCEPTORS_TAB_INDEX) {
      $scope.$broadcast('biz-interceptors:tab-selected');
    }

    $rootScope.$broadcast('profile:tabActivated', tabIndex);
  }

  $scope.$watch('selectedTabIndex', function (newIndex, oldIndex) {
    syncTabPolling(newIndex);
    // Switching tabs doesn't open a dialog or change route, so refresh here:
    // bm-requires buttons in the newly selected tab then reflect current permissions.
    if (newIndex !== oldIndex) PermissionService.refresh();
  });

  // ========================================
  // HELPERS
  // ========================================

  $scope.getHashColor = function (type) {
    var label = typeof type === 'object' ? type.refObjectLabel : type;
    var colors = [
      '#607d8b', '#8bc34a', '#03a9f4', '#ff9800', '#e91e63',
      '#9c27b0', '#009688', '#cddc39', '#ffc107', '#795548'
    ];
    var hash = 0;
    for (var i = 0; i < label.length; i++) {
      hash = label.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  $scope.getTextColor = function (label) {
    const hex = $scope.getHashColor(label);
    const r = parseInt(hex.substr(1, 2), 16);
    const g = parseInt(hex.substr(3, 2), 16);
    const b = parseInt(hex.substr(5, 2), 16);
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 140 ? '#000000' : '#ffffff';
  };

  // ========================================
  // CLEANUP
  // ========================================

  $scope.$on('$destroy', function () {
    stopAgentsPolling();
  });

  // ========================================
  // INIT
  // ========================================

  syncTabPolling($scope.selectedTabIndex);

  $scope.$on('template:statusChanged', function () {
    $rootScope.$broadcast('template:refreshEnvTemplates');
  });

});